import { useIntl, useLabels, useMapStore } from "../hooks";

export type ScaleBarProps = { maxWidth?: number; className?: string };

const earthCircumferenceMeters = 40075016.686;

export function metersPerPixel(lat: number, zoom: number, tileSize = 256): number {
  return (earthCircumferenceMeters * Math.cos((lat * Math.PI) / 180)) / (tileSize * Math.pow(2, zoom));
}

export function niceScale(maxMeters: number): number {
  if (maxMeters <= 0) return 1;

  const magnitude = Math.pow(10, Math.floor(Math.log10(maxMeters)));
  const candidates = [5, 3, 2, 1];

  for (const factor of candidates) {
    const value = factor * magnitude;

    if (value <= maxMeters) return value;
  }

  return magnitude;
}

export function ScaleBar({ maxWidth = 120, className }: ScaleBarProps) {
  const labels = useLabels();
  const intl = useIntl();
  const view = useMapStore(a => a.view);
  const perPixel = metersPerPixel(view.center[0], view.zoom);
  const meters = niceScale(maxWidth * perPixel);
  const width = Math.max(1, Math.round(meters / perPixel));

  return (
    <div className={["fxmap-scale", className ?? ""].filter(Boolean).join(" ")} data-fxmap="scale" title={labels.scale} role="img" aria-label={`${labels.scale}: ${intl.length(meters)}`}>
      <span className="fxmap-scale-line fxmap-mono" style={{ width }}>
        {intl.length(meters)}
      </span>
    </div>
  );
}
